export default __webpack_public_path__ + "static/CD-Gkn-c-4dd33e70b3bfe55bedcf87b165410739.jpeg";